module.exports = __webpack_public_path__ + "static/media/OPTIONS_ICON.73d4f504.svg";